var React = require('react');

function UploadIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7.5 12h3c.4125 0 .75-.3375.75-.75v-3.74996h1.1925c.6675 0 1.005-.81.5325-1.2825l-3.4425-3.4425c-.2925-.2925-.765-.2925-1.0575 0l-3.4425 3.4425c-.4725.4725-.1425 1.2825.525 1.2825h1.1925v3.74996c0 .4125.3375.75.75.75zm-3 1.5h9c.4125 0 .75.3375.75.75s-.3375.75-.75.75h-9c-.4125 0-.75-.3375-.75-.75s.3375-.75.75-.75z","fill":"#fff"}));
}

UploadIcon.defaultProps = {"fill":"none","height":"18","viewBox":"0 0 18 18","width":"18"};

module.exports = UploadIcon;

UploadIcon.default = UploadIcon;
